import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  TextField,
  Button,
  RadioGroup,
  FormControlLabel,
  Radio,
  Paper,
  CircularProgress,
  Slide,
  Container,
  Card,
  CardContent,
  CardMedia,
  Divider,
  Checkbox,
  List,
  ListItemText,
  Switch,
  Select,
  FormControl,
  MenuItem,
  InputLabel,
  IconButton,
  Tooltip,
  CardActionArea
} from "@mui/material";
import { ThumbUp, ThumbDown, Facebook, Twitter, LinkedIn } from "@mui/icons-material";
import SentimentSatisfiedOutlinedIcon from '@mui/icons-material/SentimentSatisfiedOutlined';
import SentimentDissatisfiedOutlinedIcon from '@mui/icons-material/SentimentDissatisfiedOutlined';
import { motion } from "framer-motion";
import Grid from "@mui/material/Grid2";
import { Phone, Email, LocationOn } from "@mui/icons-material";
import EditIcon from "@mui/icons-material/Edit";
import { Form } from "react-router-dom";
import { useParams, useLocation } from "react-router-dom";

function ThankyouPage() {
  const [clinicData, setClinicData] = useState(null);
  const [feedbackType, setFeedbackType] = useState(null);
  const [formValues, setFormValues] = useState({
    name: "",
    email: "",
    phone: "",
    preferredContact: "email",
  });
  const location = useLocation(); // Get full URL details.
  // Parse query parameters
  const searchParams = new URLSearchParams(location.search);
  const satisfactionStatus = searchParams.get("s"); // Check if 'satisfied' is present

  useEffect(() => {
    const demoData = {
      clinicName: "Delta Eye Clinic",
      primaryColor: "#E3F2FD",
      secondaryColor: "#00796B",
      logo: "https://www.eyeconx.net/clinic/templates/logos/delta_eye_logo.png",
      address: "123 Main Street, Cityville, ST 12345",
      phone: "(123) 456-7890",
      fax: "(123) 456-7899",
      backgroundImage: "https://source.unsplash.com/1600x900/?medical,clinic", // Sample background image
    };
    setClinicData(demoData);
    // if isSatisfied then setfeedback type to positive
    if (satisfactionStatus === "satisfied") {
      setFeedbackType("positive");
    } 
    if (satisfactionStatus === "not-satisfied") {
      setFeedbackType("negative");
    } 
   }, []);

  if (!clinicData) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "100vh",
          backgroundColor: "#F2F7FC",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }
  
  return (
    <Box
      sx={{
        backgroundImage: `url(${clinicData.backgroundImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "flex-start",
        padding: 3,
      }}
    >
      {/* Top Header */}
      <Box
        sx={{
          width: "100%",
          backgroundColor: `${clinicData.primaryColor}`,
          padding: 2,
          position: "absolute",
          top: 0,
          boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
          display: { xs: "none", md: "flex" }, // Hide clinic info on mobile
          justifyContent: "space-between",
        }}
      >
        <Container
          maxWidth="lg"
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <img
            src={clinicData.logo}
            alt="Clinic Logo"
            style={{ maxWidth: "500px", borderRadius: "8px" }}
          />
          <Box sx={{ textAlign: "right" }}>
            <Typography
              variant="h6"
              sx={{ color: clinicData.secondaryColor, fontWeight: "bold" }}
            >
              {clinicData.clinicName}
            </Typography>
            <Typography sx={{ fontSize: "14px", color: "#555" }}>
              {clinicData.address}
            </Typography>
            <Typography sx={{ fontSize: "14px", color: "#555" }}>
              📞 {clinicData.phone} | 📠 {clinicData.fax}
            </Typography>
          </Box>
        </Container>
      </Box>

      {/* Logo for Mobile */}
      <Box
        sx={{
          display: { xs: "flex", md: "none" },
          justifyContent: "center",
          alignItems: "center",
          width: "100%",
          mt: 4,
        }}
      >
        <img
          src={clinicData.logo}
          alt="Clinic Logo"
          style={{ maxWidth: "600px" }}
        />
      </Box>

      {/* Form Section */}
      <Slide direction="up" in={true} mountOnEnter unmountOnExit>
       
        

         
        <Container maxWidth="md"  elevation={4} sx={{ textAlign: "center",  marginTop: { xs: 5, md: 14 } }}>
        {!feedbackType && (
          <Card elevation={6} sx={{paddingTop:4,paddingBottom:4}}>
            <CardContent>
              <Typography variant="h5" gutterBottom sx={{ color: clinicData.secondaryColor}}>
              Thank you for taking the time to share your feedback about your recent visit with {clinicData.clinicName}. 
              </Typography>
             

              <Grid container spacing={2} mt={3} justifyContent="center">
                <Grid item>
                  <motion.div whileHover={{ scale: 1.1 }}>
                    <Tooltip title="I was satisfied" placement="bottom">
                    {/* Positive Icon */}
                      <IconButton  onClick={() => setFeedbackType("positive")} color="success" sx={{ fontSize: 80 }}>
                        <SentimentSatisfiedOutlinedIcon sx={{ fontSize: 80 }} />
                      </IconButton>
                      </Tooltip>
                  </motion.div>
                </Grid>
                <Grid item>
                  <motion.div whileHover={{ scale: 1.1 }}>
                  <Tooltip title="I was not satisfied" placement="bottom">
                     {/* Negative Icon */}
                    <IconButton  onClick={() => setFeedbackType("negative")} color="error" sx={{ fontSize: 80 }}>
                      <SentimentDissatisfiedOutlinedIcon sx={{ fontSize: 80 }} />
                    </IconButton>
                    </Tooltip>
                  </motion.div>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        )}

        {feedbackType === "positive" && (
          <Card elevation={6} sx={{paddingTop:4,paddingBottom:4}}>
            <CardContent>
              <Typography variant="h6" sx={{ color: clinicData.secondaryColor }}>Thank you!</Typography>
              <Typography variant="body1" sx={{ color: clinicData.secondaryColor }}>We would appreciate if you took a few moments to share your experience with others by writing an online review.</Typography>
              <Typography variant="body1" sx={{ color: clinicData.secondaryColor }}>Your vote of confidence is much appreciated and will help other patients make informed decisions</Typography>

              <Box display="flex" justifyContent="center" mt={4} p={2} sx={{gap:2}}>
                <Card>
                  <CardActionArea>
                    <CardContent>
                    
                      <Typography variant="body1" sx={{ color: clinicData.secondaryColor }}>Share your thoughts about your experience</Typography>
                      <Facebook fontSize="large" />
                    </CardContent>
                  </CardActionArea>
                </Card>
                <Card>
                  <CardActionArea>
                    <CardContent>
                      
                      <Typography variant="body1" sx={{ color: clinicData.secondaryColor }}>Share your thoughts about your experience</Typography>
                      <Twitter fontSize="large" />
                    </CardContent>
                  </CardActionArea>
                </Card>
                <Card>
                  <CardActionArea>
                    <CardContent>
                     
                      <Typography variant="body1" sx={{ color: clinicData.secondaryColor }}>Share your thoughts about your experience</Typography>
                      <LinkedIn fontSize="large" />
                    </CardContent>
                  </CardActionArea>
                </Card>
               
              </Box>
            </CardContent>
          </Card>
        )}

        {feedbackType === "negative" && (
          <Card elevation={6} sx={{paddingTop:4,paddingBottom:4}}>
            <CardContent>
              <Typography variant="h6"  sx={{ color: clinicData.secondaryColor }}>We value your feedback:</Typography>
              <TextField
                fullWidth
                variant="outlined"
                label="First Name (Optional)"
                margin="normal"
              />
              <TextField
                fullWidth
                variant="outlined"
                label="Last Name (Optional)"
                margin="normal"
              />
              <TextField
                fullWidth
                multiline
                rows={4}
                variant="outlined"
                label="Your feedback"
                margin="normal"
              />
              <Button variant="contained"  sx={{ backgroundColor: clinicData.secondaryColor }}>
                Submit
              </Button>
            </CardContent>
          </Card>
        )}
      </Container>
        

         


       
       
      </Slide>

      {/* Footer (Mobile Clinic Info) */}
      <Box
        sx={{
          width: "100%",
          textAlign: "center",
          marginTop:"auto",
          padding: 2,
          backgroundColor: "rgba(0, 0, 0, 0.05)",
          display: { xs: "block", md: "none" },
        }}
      >
        <Typography sx={{ fontSize: "14px", color: "#555" }}>
          {clinicData.clinicName}
        </Typography>
        <Typography sx={{ fontSize: "14px", color: "#555" }}>
          {clinicData.address}
        </Typography>
        <Typography sx={{ fontSize: "14px", color: "#555" }}>
          📞 {clinicData.phone} | 📠 {clinicData.fax}
        </Typography>
      </Box>

      {/* Footer (Desktop) */}
      <Box
        sx={{
          width: "100%",
          textAlign: "center",
          marginTop: "auto",
          padding: 2,
          backgroundColor: "rgba(0, 0, 0, 0.05)",
          display: { xs: "none", md: "block" },
        }}
      >
        <Typography sx={{ fontSize: "14px", color: "#555" }}>
          © 2025 {clinicData.clinicName}. All rights reserved.
        </Typography>
      </Box>
    </Box>
  );
}

export default ThankyouPage;
